var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew237({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-linecap:square;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.56,9.46h-.64L10.87,7.21l-.31-.72v3h-.45V5.85h.63l1,2.13.36.83v-3h.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.67,8.56a.87.87,0,0,1-.09.4.83.83,0,0,1-.26.3,1.24,1.24,0,0,1-.4.19,2,2,0,0,1-.5.06,2.06,2.06,0,0,1-.52-.06,1.35,1.35,0,0,1-.38-.19A.89.89,0,0,1,13.29,9a.86.86,0,0,1-.07-.36.92.92,0,0,1,.18-.57A1.79,1.79,0,0,1,14,7.61a1.44,1.44,0,0,1-.51-.4.82.82,0,0,1-.17-.5.81.81,0,0,1,.08-.34.86.86,0,0,1,.21-.29,1.18,1.18,0,0,1,.37-.2,1.52,1.52,0,0,1,.51-.08,1.77,1.77,0,0,1,.49.06,1.2,1.2,0,0,1,.36.17.71.71,0,0,1,.21.27.91.91,0,0,1-.1.88,1.55,1.55,0,0,1-.5.39,1.49,1.49,0,0,1,.3.18,1.21,1.21,0,0,1,.24.21.92.92,0,0,1,.16.27A.88.88,0,0,1,15.67,8.56Zm-.52,0a.69.69,0,0,0,0-.2A.5.5,0,0,0,15,8.2,1.66,1.66,0,0,0,14.77,8l-.36-.19a1.82,1.82,0,0,0-.32.18,1,1,0,0,0-.21.18.61.61,0,0,0-.14.41.42.42,0,0,0,0,.22.75.75,0,0,0,.15.16,1.12,1.12,0,0,0,.22.1,1.32,1.32,0,0,0,.56,0A.79.79,0,0,0,15,9a.57.57,0,0,0,.15-.16A.52.52,0,0,0,15.15,8.59Zm-.05-1.9a.43.43,0,0,0-.17-.37.87.87,0,0,0-.49-.12.85.85,0,0,0-.48.12.42.42,0,0,0-.17.36.48.48,0,0,0,0,.2.64.64,0,0,0,.13.17,1.39,1.39,0,0,0,.22.15,1.49,1.49,0,0,0,.31.16,1.83,1.83,0,0,0,.46-.3A.53.53,0,0,0,15.1,6.69Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 0.97,
    y: 5.34,
    width: 7.88,
    height: 4.52
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew237);
export default __webpack_public_path__ + "static/media/Symbolpack_New_237.dfdbc3c544ec0eeb835d3d656b097fb0.svg";
export { ForwardRef as ReactComponent };